import { clearGeo } from '../../../packages/JsonQuery/clearGeo';
import { setRegionId } from '../../../packages/JsonQuery/setRegionId';
import { unsetUndergroundTravel } from '../../../packages/JsonQuery/unsetUndergroundTravel';
import { selectLocation } from 'shared/selectors/location';
import { TLocation } from 'shared/types/location';
import { TThunkAction } from 'shared/types/redux';
import { isNormalLocation, needClearGeo, needClearGeoLocation } from 'shared/utils/geo';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { clearGeoLocation } from '../../../packages/JsonQuery/clearGeoLocation';
import { getTermValue } from '../../../packages/JsonQuery';
import { checkEarlyAccessAvailability } from 'shared/utils/earlyAccess';
import { setEarlyAccess } from '../../../packages/JsonQuery/setEarlyAccess';

export const updateRegion =
  (nextLocation: TLocation): TThunkAction =>
  (dispatch, getState, { config }) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);
    const currentLocation = selectLocation(state);

    let value: number[] = [];

    if (nextLocation === 'moscow_mo') {
      value = [1, 4593];
    } else if (nextLocation === 'spb_lo') {
      value = [2, 4588];
    } else if (nextLocation) {
      value = [nextLocation.id];
    }

    const actions = [setRegionId];

    if (needClearGeo(nextLocation, currentLocation)) {
      actions.push(clearGeo, unsetUndergroundTravel);
    } else if (
      isNormalLocation(currentLocation) &&
      needClearGeoLocation({ currentLocation, nextLocation, jsonQuery })
    ) {
      actions.push(clearGeoLocation(currentLocation.id));
    }

    let nextJsonQuery = actions.reduce((state, action) => action(state)(value), jsonQuery);

    /**
     * @description
     * Очищаем ранний доступ, если он включен, но в новом регионе он не доступен
     */
    const isEarlyAccessOn = Boolean(getTermValue('is_early_access_enabled')(jsonQuery));

    if (isEarlyAccessOn && !checkEarlyAccessAvailability({ jsonQuery: nextJsonQuery, config })) {
      nextJsonQuery = setEarlyAccess(nextJsonQuery)(null);
    }

    dispatch(setJsonQuery(nextJsonQuery));
  };
